
import {INotificationService} from '../services/NotificationService'
import Component from 'vue-class-component'
import Vue from 'vue'
import RoleService from '../services/RoleService'
import RoleTemplate from '../templates/roleTemplate'
import Role from '../models/role'
import PermissionTemplate from '../templates/permissionTemplate'
import PermissionService from '../services/permissionService'
import Permission, {Category} from '../models/permission'
import CreateRole from '../components/CreateRole.vue'
import DeleteRole from '../components/DeleteRole.vue'
import {Watch} from 'vue-property-decorator'
import Iterator from '../components/Layout/Iterator.vue'
import CardTitle from '../components/Atomic/CardTitle.vue'
import GreenButton from '../components/Atomic/GreenButton.vue'
import ProgressLinear from '../components/Atomic/ProgressLinear.vue'
import HelpTooltip from '../components/Atomic/HelpTooltip.vue'
import RedButton from '../components/Atomic/RedButton.vue'
import SearchField from '@/components/Atomic/SearchField.vue'
import {State} from 'vuex-class'
import Permissions from '@/models/constants/Permissions'
import Schools from '@/models/schools'
import ToolTipButton from '@/components/Atomic/ToolTipButton.vue'

@Component({
  components: {
    ToolTipButton,
    Iterator,
    CreateRole,
    DeleteRole,
    CardTitle,
    GreenButton,
    HelpTooltip,
    RedButton,
    SearchField,
    ProgressLinear,
  },
})
export default class Roles extends Vue {
  @State('user') public user!: any
  public permissions: PermissionTemplate[] = []
  public roles: RoleTemplate[] = []
  public filteredRoles: RoleTemplate[] = []
  public rolesBases: RoleTemplate[] = []
  public show: boolean = false
  public checked: boolean[][] = [[], []]
  private $notificationService!: INotificationService
  private schools: Schools[] = []
  private editDialog: object = {}
  private search: string = ''
  private isLoading: boolean = false
  private isButtonLoading: boolean = false
  private resetCreateData: boolean = false
  private selectedEstablishmentId?: number = 0
  private permissionCategories: Category[] = []
  private permissionPerCategory: { key?: Permission[] } = {}
  private permissionPerCategoryProtected: { key?: Permission[] } = {}

  private tab: any = null

  constructor() {
    super()
  }

  public mounted() {
    // let myTimerPromise = this.getPromiseToDelayLoader(true, 100);
    // myTimerPromise = this.getPromiseToDelayLoader(false, 2000);
    this.initialize()
  }

  private get hasAccessToAllRoles(): boolean {
    const allowed = [Permissions.ManageRoles]
    if (
        (this.user.permissions as []).some((permission) =>
            allowed.includes(permission),
        )
    ) {
      return true
    }
    return false
  }

  private get hasAccessToSchoolRoles(): boolean {
    const allowed = [Permissions.ManageSchoolRoles]
    if (
        (this.user.permissions as []).some((permission) =>
            allowed.includes(permission),
        )
    ) {
      return true
    }
    return false
  }

  private async initialize() {
    this.isLoading = true
    this.roles = []
    this.search = ''
    this.selectedEstablishmentId = undefined
    this.filteredRoles = []
    this.permissions = []
    this.permissionPerCategory = {}
    this.permissionPerCategoryProtected = {}

    await this.fetchPermissionsCategories()

    await PermissionService.get().then((res: Permission[]) => {
      res.forEach((p: Permission) => {
        this.permissions.push(new PermissionTemplate(p))
        const permissionCategory = p.category
        if (!this.permissionPerCategory[permissionCategory]) {
          this.permissionPerCategory[permissionCategory] = []
        }
        if (p.protected) {
          if (!this.permissionPerCategoryProtected[permissionCategory]) {
            this.permissionPerCategoryProtected[permissionCategory] = []
          }
          this.permissionPerCategoryProtected[permissionCategory].push(p)
        }
        this.permissionPerCategory[permissionCategory].push(p)
      })
    })
    this.getSchools()

    this.isLoading = false
  }

  private async fetchPermissionsCategories() {
    this.permissionCategories = await PermissionService.getPermissionsCategories()
  }

  private getSchoolName(school_id: number) {
    if (school_id !== -2) {
      const schoolObject = this.schools.find(
          (school) => school.etablissement_id === school_id,
      )
      if (schoolObject) {
        return schoolObject.nom
      }
    }
  }

  private getSchools() {
    this.schools = Object.assign([], this.user.schools)
    if (this.hasAccessToAllRoles) {
      this.schools.unshift({etablissement_id: -2, nom: 'Globaux'})
    }
  }

  private async getPromiseToDelayLoader(state: boolean, milliseconds: number) {
    return new Promise<void>((resolve, reject) => {
      setTimeout(() => {
        resolve()
      }, milliseconds)
    })
  }

  @Watch('search')
  private filterRole() {
    this.filteredRoles = this.roles.filter((role) => {
      if (!this.search) {
        return true
      }
      if (role.name.toLowerCase().includes(this.search.toLowerCase())) {
        return true
      }
      if (role.schoolId) {
        if (role.schoolId.toString().includes(this.search.toLowerCase())) {
          return true
        }
        const schoolName = this.getSchoolName(role.schoolId)
        if (schoolName) {
          if (schoolName.toLowerCase().includes(this.search.toLowerCase())) {
            return true
          }
        }
      }
    })
  }

  private async onSelectedEstablishmentIdChanged(schoolID: number) {
    this.roles = []
    this.filteredRoles = []
    if (schoolID) {
      await RoleService.getForSchool(schoolID).then((res: Role[]) => {
        res.forEach((r: Role) => {
          this.roles.push(new RoleTemplate(r))
          this.filteredRoles.push(new RoleTemplate(r))
        })
      })
    }
    this.filterRole()
  }

  private clearDataTable() {
    this.roles = []
    this.filteredRoles = []
    this.search = ''
  }

  private prepareDelete(roleTemplate: RoleTemplate) {
    (this.$refs.deleteRole as any).show(roleTemplate)
  }

  private async createRole(role: Role) {
    await RoleService.create(role)
        .then((response) => {
          this.roles.push(new RoleTemplate(response))
          this.$notificationService.success(
              this.$t('ROLE.CreationRoleSuccess').toString(),
          )
        })
        .catch((error: any) => {
          this.$notificationService.error(
              this.$t('ROLE.CreationRoleFailed').toString(),
          )
        })
    if (this.selectedEstablishmentId) {
      this.onSelectedEstablishmentIdChanged(this.selectedEstablishmentId)
    }
  }

  private async updateRole(role: RoleTemplate) {
    this.isLoading = true
    const result = await RoleService.update(role.getItem(), role.id)
        .then((response) => {
          role.toChange = false
          this.$notificationService.success(
              this.$t('ROLE.UpdateRole').toString() +
              role.name +
              ' ' +
              this.$t('ROLE.UpdateRoleSuccess').toString(),
          )
        })
        .catch((error: any) => {
          this.$notificationService.error(
              this.$t('ROLE.UpdateRole').toString() +
              role.name +
              this.$t('ROLE.UpdateRoleFailed').toString(),
          )
        })
    this.isLoading = false
  }

  private async deleteRole(role: RoleTemplate) {
    const result = await RoleService.delete(role.id)
        .then((response) => {
          this.$notificationService.success(
              this.$t('ROLE.DeleteRole').toString() +
              role.name +
              ' ' +
              this.$t('ROLE.DeleteRoleSuccess').toString(),
          )
        })
        .catch((error: any) => {
          this.$notificationService.error(
              this.$t('ROLE.DeleteRole').toString() +
              role.name +
              this.$t('ROLE.DeleteRoleFailed').toString(),
          )
        })
    if (this.selectedEstablishmentId) {
      this.onSelectedEstablishmentIdChanged(this.selectedEstablishmentId)
    }
  }

  private setPermissions(roleId: number, permissionId: number, name: string) {
    const index: number = this.roles.findIndex(
        (r: RoleTemplate) => r.id === roleId,
    )
    this.roles[index].setAppPermissions(permissionId)
  }

  private get getNumberOfItemsPerSize() {
    if (this.$vuetify.breakpoint.xlOnly) {
      return 10
    }
    if (this.$vuetify.breakpoint.lgOnly) {
      return 6
    }
    if (this.$vuetify.breakpoint.mdOnly) {
      return 3
    }
    return 2
  }

  private async save() {
    this.resetCreateData = true
    this.isButtonLoading = true
    const myTimerPromise = this.getPromiseToDelayLoader(true, 100)

    this.roles.forEach((r: RoleTemplate) => {
      if (r.toChange) {
        r.appPermissions.length >= 1
            ? this.updateRole(r)
            : this.$notificationService.warning(
                this.$t('ROLE.DeleteRole').toString() +
                r.name +
                this.$t('ROLE.UpdateSingleRoleFailed').toString(),
            )
      } else if (r.toDelete) {
        this.deleteRole(r)
      }
    })
    const myTimerPromiseBis = await this.getPromiseToDelayLoader(false, 5000)
    if (this.selectedEstablishmentId) {
      this.onSelectedEstablishmentIdChanged(this.selectedEstablishmentId)
    }
    this.isButtonLoading = false
    this.resetCreateData = false
  }
}
